var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0846146c-283e-43e2-ada8-7781cf93a3da",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.98 17.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-53a7fd23-73aa-4f05-be0b-f7f0f24e6fd8 {\n        opacity: .56;\n      }\n\n      .uuid-53a7fd23-73aa-4f05-be0b-f7f0f24e6fd8, .uuid-97681e4c-b877-45c2-b96e-a9868f0936a7 {\n        fill: #f7931e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-666f7cff-38a1-45c4-b2d1-ad4a7b7bb629",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-97681e4c-b877-45c2-b96e-a9868f0936a7",
    d: "M17.24,17.46H1.88c-1.43,0-2.33-1.53-1.65-2.78L7.41,1.53c.69-1.26,2.49-1.32,3.25-.09l8.18,13.15c.78,1.25-.12,2.87-1.6,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-53a7fd23-73aa-4f05-be0b-f7f0f24e6fd8",
    d: "M23.1,17.46h-6.29c-1.44,0-2.34-1.54-1.64-2.8l3.22-5.76c.73-1.3,2.6-1.28,3.3,.03l3.07,5.76c.67,1.25-.24,2.76-1.66,2.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-97681e4c-b877-45c2-b96e-a9868f0936a7",
    cx: 17.91,
    cy: 2.45,
    r: 2.45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f321f3e35f84cf31a51a1a3fecd26d0f.svg";
export { ForwardRef as ReactComponent };